import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

const EncryptorNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="encryptor" />;
};

export default EncryptorNode;
